<template>
    <section>
        <div class="d-flex align-center py-3">
            <v-icon class="mr-2" large :color="iconColor">{{ icon }}</v-icon>
            <h2 class="text-h6 font-weight-medium">{{ title }}</h2>
        </div>

        <v-row>
            <v-col v-if="displayTitlesView">
                <title-list
                    :displayNewBadge="false"
                    :titles="items"
                    :loading="loadingTitles"
                    displayBorder
                    displayUserTypeLabel
                    :displayInCols="isMobilePort ? 12 : 6">
                </title-list>
            </v-col>
            <v-col v-else v-for="(item, index) in items" :key="index" cols="12" sm="6">
                <component :is="item.url ? 'a' : 'div'" :href="item.url || null">
                    <v-card class="pa-4 hover-border rounded-lg" outlined>
                        <div class="text-body-1 font-weight-medium">{{ item.title }}</div>
                    </v-card>
                </component>
            </v-col>
        </v-row>

        <v-divider class="my-3" v-if="!hideDivider"></v-divider>
    </section>
</template>

<script>
    import TitleList from '../content/title/TitleList.vue';
    import Mobile from '../inc/mixins/mobile';

    export default {
        name: 'SectionList',
        props: {
            title: String,
            icon: String,
            items: Array,
            iconColor: {
                type: String,
                default: 'primaryMedium'
            },
            hideDivider: {
                type: Boolean,
                default: false
            },
            displayTitlesView: {
                type: Boolean,
                default: false
            },
            loadingTitles: {
                type: Boolean,
                default: false
            }
        },
        components: {TitleList},
        mixins: [Mobile]
    }
</script>
